"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlippage = exports.getDoubleSwapSlippage = exports.getSingleSwapSlippage = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const utils_1 = require("../../../utils");
const getTradeRate_1 = require("../utils/getTradeRate/getTradeRate");
const isRune_1 = require("../utils/isRune/isRune");
const thorService_1 = require("../utils/thorService");
const getSingleSwapSlippage = ({ inputAmountThorPrecision, pool, toRune, }) => {
    // formula: (inputAmount) / (inputAmount + inputBalance)
    const inputBalance = toRune ? pool.balance_asset : pool.balance_rune; // input is asset if toRune
    const denominator = inputAmountThorPrecision.plus(inputBalance);
    return inputAmountThorPrecision.div(denominator);
};
exports.getSingleSwapSlippage = getSingleSwapSlippage;
const getDoubleSwapSlippage = ({ inputAmountThorPrecision, sellPool, buyPool, }) => {
    // formula: getSwapOutput(input1) + getSingleSwapSlippage(getSwapOutput(input1) => input2)
    const firstSwapSlippage = (0, exports.getSingleSwapSlippage)({
        inputAmountThorPrecision,
        pool: sellPool,
        toRune: true,
    });
    const firstSwapOutput = (0, getTradeRate_1.getSwapOutput)(inputAmountThorPrecision, sellPool, true);
    const secondSwapSlippage = (0, exports.getSingleSwapSlippage)({
        inputAmountThorPrecision: firstSwapOutput,
        pool: buyPool,
        toRune: false,
    });
    return firstSwapSlippage.plus(secondSwapSlippage);
};
exports.getDoubleSwapSlippage = getDoubleSwapSlippage;
const getSlippage = async ({ inputAmountThorPrecision, daemonUrl, buyAssetId, sellAssetId, }) => {
    try {
        const { data: poolData } = await thorService_1.thorService.get(`${daemonUrl}/lcd/thorchain/pools`);
        const buyPoolId = caip_1.adapters.assetIdToPoolAssetId({ assetId: buyAssetId });
        const sellPoolId = caip_1.adapters.assetIdToPoolAssetId({ assetId: sellAssetId });
        const buyPool = buyPoolId ? poolData.find((response) => response.asset === buyPoolId) : null;
        const sellPool = sellPoolId ? poolData.find((response) => response.asset === sellPoolId) : null;
        const toRune = (0, isRune_1.isRune)(buyAssetId);
        const fromRune = (0, isRune_1.isRune)(sellAssetId);
        switch (true) {
            case toRune: {
                (0, utils_1.assertIsDefined)(sellPool);
                return (0, exports.getSingleSwapSlippage)({
                    inputAmountThorPrecision,
                    pool: sellPool,
                    toRune,
                });
            }
            case fromRune: {
                (0, utils_1.assertIsDefined)(buyPool);
                return (0, exports.getSingleSwapSlippage)({
                    inputAmountThorPrecision,
                    pool: buyPool,
                    toRune,
                });
            }
            default: {
                (0, utils_1.assertIsDefined)(sellPool);
                (0, utils_1.assertIsDefined)(buyPool);
                return (0, exports.getDoubleSwapSlippage)({ inputAmountThorPrecision, sellPool, buyPool });
            }
        }
    }
    catch (e) {
        throw new Error(`Failed to get pool data: ${e}`);
    }
};
exports.getSlippage = getSlippage;
